import { action, observable } from "mobx";

import { RootStore } from "@state/stores/types";
import BasePopupStore from "@state/stores/popups/BasePopupStore";

export default class BetBuilderPopupStore extends BasePopupStore {
	rootStore: RootStore;
	@observable public betBuilderInfoText: string = "";
	public betBuilderRoutingCallback: null | Function = null;

	constructor(rootStore: RootStore) {
		super(rootStore);
		this.rootStore = rootStore;
	}

	@action.bound
	public activateBetBuilderPopup(
		infoText: string,
		callback: (() => void) | null
	) {
		this.activatePopup();
		this.betBuilderInfoText = infoText;
		this.betBuilderRoutingCallback = callback;
	}

	@action.bound
	public deactivateBetBuilderPopup() {
		this.deactivatePopup();
		this.betBuilderInfoText = "";
		this.betBuilderRoutingCallback = null;
	}
}
